// extracted by mini-css-extract-plugin
export default {"nonAuthContainer":"OriginRedirect_nonAuthContainer__CIgGM","redirectBox":"OriginRedirect_redirectBox__gamFS"};